<template>
  <div class="page">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Page'
}
</script>
